/* VD focus trap — shared accessibility helper for modal overlays (cart drawer, mobile nav,
   search overlay, filter sheet). Traps Tab within a container, moves focus in on open, restores
   focus to the opener on close, and (optionally) calls onEscape for the Escape key.

   Usage:
     var release = window.vdTrapFocus(panelEl, { onEscape: closeFn, initial: someEl });
     // ...later, on close:
     release();

   Idempotent-friendly: store the returned release fn on the container and call it before re-trapping. */
(function () {
  var SEL = 'a[href],area[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),' +
    'select:not([disabled]),textarea:not([disabled]),iframe,audio[controls],video[controls],' +
    '[contenteditable]:not([contenteditable="false"]),[tabindex]:not([tabindex="-1"])';

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) &&
      getComputedStyle(el).visibility !== 'hidden';
  }
  function focusable(container) {
    return Array.prototype.filter.call(container.querySelectorAll(SEL), visible);
  }

  window.vdTrapFocus = function (container, opts) {
    opts = opts || {};
    var prev = document.activeElement;

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (opts.onEscape) { opts.onEscape(e); }
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusable(container);
      if (!f.length) { e.preventDefault(); if (container.focus) container.focus(); return; }
      var first = f[0], last = f[f.length - 1], active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !container.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !container.contains(active)) { e.preventDefault(); first.focus(); }
      }
    }

    document.addEventListener('keydown', onKey, true);

    // move focus into the dialog
    var target = opts.initial && visible(opts.initial) ? opts.initial : (focusable(container)[0] || container);
    // container itself may need a tabindex to be focusable as a fallback
    if (target === container && !container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1');
    try { target.focus(); } catch (e) {}

    return function release() {
      document.removeEventListener('keydown', onKey, true);
      if (opts.restore === false) return;
      if (prev && prev.focus) { try { prev.focus(); } catch (e) {} }
    };
  };
})();
